export enum SliderType {
  AWARD = 'award',
  TEASER = 'teaser',
  QUOTES = 'quotes',
}
